import { render } from "./Challenge.vue?vue&type=template&id=36051214&scoped=true"
import script from "./Challenge.vue?vue&type=script&lang=js"
export * from "./Challenge.vue?vue&type=script&lang=js"

import "./Challenge.vue?vue&type=style&index=0&id=36051214&scoped=true&lang=css"

import exportComponent from "/home/runner/work/cloud-builder-challenge-frontend/cloud-builder-challenge-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36051214"]])

export default __exports__